import compact from 'lodash/compact';

import {activeLineLayers} from './constants';
import {knownRouteFixedLayerIds} from './fixedLayerIds';
export interface GetKnownRoutesMapboxStyleOptions {
    showKnownRoutes: boolean;
    knownRoutes: Record<number, KnownRouteTag>;
    selections: SelectionState[];
    interactionType: InteractionState['type'];
}

export default function getKnownRoutesMapboxStyle({
    showKnownRoutes,
    knownRoutes,
    selections,
    interactionType,
}: GetKnownRoutesMapboxStyleOptions): mapboxgl.Style | undefined {
    const shouldDim = selections.length > 0 || interactionType !== 'normal';
    const osmKnownRoutes: KnownRouteTag[] = compact(
        selections
            .filter((s): s is OSMSelectionState => s.type === 'osm')
            .map((osmS) => osmS.hoverKnownRouteId)
    ).map((krId) => knownRoutes[krId]);

    const selectedKnownRoutes: KnownRouteTag[] = compact(
        selections
            .filter(
                (s): s is KnownRouteSelectionState | ExplorationSelectionState =>
                    s.type === 'knownRoute' || s.type === 'exploration'
            )
            .map((krs) => krs.knownRouteId)
    ).map((krId) => knownRoutes[krId]);

    const focusedKnownRoutes = compact([...osmKnownRoutes, ...selectedKnownRoutes]);

    const savedKnownRoutes = showKnownRoutes
        ? Object.values(knownRoutes)
              .filter((kr) => kr.isSaved)
              .filter(
                  (kr) => !focusedKnownRoutes.reduce((acc, fkr) => acc || fkr.id === kr.id, false)
              )
        : [];

    return {
        version: 8,
        metadata: {
            id: 'knownRoutes',
        },
        sources: {
            savedKnownRoutes: {
                type: 'geojson',
                data: {
                    type: 'FeatureCollection',
                    features: savedKnownRoutes.map(({id, name, geometry}) => {
                        return {
                            type: 'Feature',
                            geometry,
                            properties: {id, title: name},
                        };
                    }),
                },
            },
            focusedKnownRoutes: {
                type: 'geojson',
                data: {
                    type: 'FeatureCollection',
                    features: focusedKnownRoutes.map(({id, name, geometry}) => {
                        return {
                            type: 'Feature',
                            geometry,
                            properties: {id, title: name},
                        };
                    }),
                },
            },
        },
        layers: [
            {
                id: knownRouteFixedLayerIds.saved,
                type: 'line',
                source: 'savedKnownRoutes',
                paint: {
                    'line-color': 'rgb(45, 94, 56)',
                    'line-width': 3,
                    'line-opacity': shouldDim ? 0.5 : 1,
                },
            },
            ...activeLineLayers(
                knownRouteFixedLayerIds.focused,
                knownRouteFixedLayerIds.focusedShadow,
                'focusedKnownRoutes'
            ),
        ],
    };
}
